/** @module Sourcing/MassActionSupplierResponses */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/locale",
	"underscore",
	"./_MassActionsMixin"
], function(declare,Controller,locale,_,_MassActionsMixin) {

	return declare([Controller,_MassActionsMixin], {

		/**
		 * @override
		 * Generate success message
		 */
		postProcessSuccess: function() {
			var resource = "";
			if (this.m_action.m_id == "MassApproveSupplierResponses") resource = "MassApproveResponse_Success";
			if (this.m_action.m_id == "MassReopenSupplierResponses")  resource = "MassReopenResponse_Success";
			if (this.m_action.m_id == "MassReviseSupplierResponses")  resource = "MassReviseResponse_Success";
			if (this.m_action.m_id == "MassCloseSupplierResponses")  resource = "MassCloseResponse_Success";
			if (this.m_action.m_id == "MassFreezeSupplierResponses")  resource = "MassFreezeResponse_Success";

			this.massActionErrors = this.massActionErrors || [];
			var numTotalResponses = this.m_formData.getSelectedNodes().length;
			var numSuccessResponses = numTotalResponses - this.massActionErrors.length;
			this.massActionSuccessMessage = locale.resource(resource, [numSuccessResponses]);

			// display "Some Failed" message
			if (this.massActionErrors.length > 0) {
				var statusMsg = locale.resource("MassActionResponse_SomeFailed", [numSuccessResponses, numTotalResponses]);
				for (var i = 0; i < this.massActionErrors.length; i ++) {
					var supplierResponse = this.m_cache.getNode(this.massActionErrorCNLs[i]);
					// sometimes the supplierResponse is the actual supplierResponse or the revision
					if (supplierResponse.$Type == "SpecificationDataSheetSupplierResponseRevision") {
						supplierResponse = this.m_cache.getNode(supplierResponse.__Parent__);
					}
					var product = this.m_cache.getPathNode(supplierResponse, "Child:__Parent__/Child:__Parent__/Child:__Parent__");
					statusMsg += "\n" + locale.resource("MassActionResponse_EachError", [product.$Name, supplierResponse.$Name, this.massActionErrors[i]]);
				}

				this.displayErrorDialog({
					title: locale.resource("MassActionResponse_Title"),
					message: statusMsg,
					onResponse: function() {}
				});
			}
			return this.inherited(arguments);
		}
	});
});
